var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-reg-form"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('section', {
    staticClass: "col-md-6 pr-lg-5"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "input-field form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.firstName,
      expression: "firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.firstName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value;
      }
    }
  }), _c('label', {
    class: _vm.firstName ? 'top-label' : ''
  }, [_vm._v("First Name")]), _vm.getError('firstName') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e()])]), _c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "input-field form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.lastName,
      expression: "lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.lastName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value;
      }
    }
  }), _c('label', {
    class: _vm.lastName ? 'top-label' : ''
  }, [_vm._v("Last Name")]), _vm.getError('lastName') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e()])]), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v(" Please provide your real name as it appears on your Passport/ID. It is mandatory to comply with this requirement in order to avoid disqualification. ")]), _c('br'), _c('br'), false ? _c('div', {
    staticClass: "select-field form-group"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "label": "label",
      "options": [{
        label: 'Male',
        value: 0
      }, {
        label: 'Female',
        value: 1
      }],
      "reduce": function (e) {
        return e.value;
      },
      "clearable": false,
      "id": "gender"
    },
    model: {
      value: _vm.gender,
      callback: function ($$v) {
        _vm.gender = $$v;
      },
      expression: "gender"
    }
  }), _vm.getError('gender') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("required")]) : _vm._e()], 1) : _vm._e(), _vm.dob_required ? _c('div', {
    staticClass: "input-field form-group mt-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.dob,
      expression: "dob"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "datePickerId"
    },
    domProps: {
      "value": _vm.dob
    },
    on: {
      "change": function ($event) {
        return _vm.getDOBYear();
      },
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.dob = $event.target.value;
      }
    }
  }), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v("Your DOB must match the DOB on your Passport/ID")]), _vm.getError('dob') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("required")]) : _vm._e()]) : _vm._e(), _vm.dob_required && _vm.isDOBProofRequired ? _c('div', {
    staticClass: "custom-file form-group mt-0 mb-5"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "id": "dob-certificate",
      "type": "file",
      "accept": "image/*,.pdf"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileUpload('dobCertificate', $event);
      }
    }
  }), _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "dob-certificate"
    }
  }, [_vm._v("Upload Passport / ID (Images or PDF)")]), _c('div', {
    staticClass: "fileName"
  }, [_vm._v(_vm._s(_vm.getFileName()))]), _vm.getError('dobCertificate') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e(), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v(" According to your DOB, you are eligible for Youth/Masters classification (Please upload your Passport/ID proof in .jpg, .png or .pdf format for verification). ")])]) : _vm._e(), _c('div', {
    staticClass: "input-field form-group mt-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }
    }
  }), _c('label', {
    class: _vm.email ? 'top-label' : ''
  }, [_vm._v("Account Email")]), _vm.getError('email') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please provide a valid email address ")]) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }